/** @typedef {import('../../types/finance').Dispute} Dispute */

import { useEffect, useState } from 'react';
import { useInfiniteQuery } from 'react-query';

import { fetchDisputes } from '../../api';
import { queryClient } from '../../config';
import { generatedDates, handleQueryError } from '../../utils';

/** @returns {{ recentDisputes: Dispute[], disputes: Dispute[], isFetching: boolean, isLoading: boolean, isFetchingNextPage: boolean, fetchNextPage: Function, hasNextPage: boolean, searchQuery: string, setSearchQuery: Function, isRefetching: boolean, setStatus: Function, status: string, filterByDate: Function, refetch: Function }} */
const useFetchDsiputes = () => {
  const [disputes, setDisputes] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [status, setStatus] = useState('');
  const [dateFilter, setDateFilter] = useState({ from: '', to: '' });
  let recentDisputes = [];
  const {
    isLoading,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetching,
    isFetchingNextPage,
    isRefetching,
    data,
    error,
    refetch
  } = useInfiniteQuery(
    'allDisputes',
    ({ pageParam }) => fetchDisputes({ offset: pageParam, searchQuery, status, dateFilter }),
    {
      getNextPageParam: (lastPage) => {
        const { hasNext } = lastPage.meta ?? {};

        const lastDispute = lastPage && lastPage.data[lastPage.data.length - 1];

        return hasNext ? lastDispute && lastDispute && lastDispute.id : undefined;
      }
    }
  );

  if (isError) {
    handleQueryError(error, 'disputes');
  }

  useEffect(() => {
    if (data && data.pages) {
      let aggregatedDisputes = [];

      data.pages.map(({ data: disputesList = {} }) => {
        aggregatedDisputes = [...aggregatedDisputes, ...disputesList];
      });
      setDisputes(aggregatedDisputes);
    }
  }, [data]);

  recentDisputes = disputes.slice(0, 4);

  useEffect(() => {
    setDisputes([]);
    queryClient.removeQueries('allDisputes', { exact: true });

    refetch({ refetchPage: (page, index) => index === 0, resetQueries: true });
  }, [searchQuery, status, dateFilter]);
  const filterByDate = (dateType) => {
    if (dateType) {
      setDateFilter({ from: generatedDates[dateType](), to: generatedDates.now() });
    } else {
      setDateFilter({ from: null, to: null });
    }
  };

  return {
    recentDisputes,
    disputes,
    isFetching,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    searchQuery,
    setSearchQuery,
    isRefetching,
    setStatus,
    status,
    filterByDate,
    refetch
  };
};

export { useFetchDsiputes };
